import React, { FC } from 'react';
import { getTestingAttributes } from 'app/functions';
import { elements } from 'app/tests/elements';
import { useDispatch, useSelector } from 'react-redux';
import { isSearchInvalid } from 'app/functions/general';
import { requestSearch, updateFocusedPart } from 'app/store/actions';
import {
  arrivalCitySelector,
  departureCitySelector,
  departureDateTimestampSelector,
  passengerCountSelector,
  wheelchairSelectedSelector,
} from 'app/store/selectors';
import styles from './SearchButton.scss';
import { useTranslations } from 'app/hooks/useTranslations';
import { CityDetailsResult } from 'app/models/types/store/location';
import { Button } from '@flixbus/honeycomb-react';
import { a11yLabelsKeys } from 'app/providers/a11yLabels';

export const SearchButton: FC = () => {
  const departureCity = useSelector(departureCitySelector);
  const arrivalCity = useSelector(arrivalCitySelector);
  const departureDate = useSelector(departureDateTimestampSelector);
  const passengerCount = useSelector(passengerCountSelector);
  const wheelchairsCount = useSelector(wheelchairSelectedSelector);

  const dispatch = useDispatch();

  const { getSearchString, getSearchButtonAriaLabel } = useTranslations({
    getSearchString: 'Booking find',
    getSearchButtonAriaLabel: a11yLabelsKeys.searchButton,
  });

  const handleClick = () => {
    if (!departureCity.uuid || !arrivalCity.uuid) {
      return;
    }

    dispatch(requestSearch());
  };

  const handleFocus = () => {
    dispatch(updateFocusedPart('button'));
  };

  return (
    <div {...getTestingAttributes(elements.SEARCH_BUTTON)} className={styles.searchButtonWrapper}>
      <Button
        appearance="primary"
        aria-label={getSearchButtonAriaLabel()}
        extraClasses={styles.searchButton}
        onClick={handleClick}
        onFocus={handleFocus}
        disabled={isSearchInvalid({
          passengerCount,
          departureDate,
          wheelchairsCount,
          departureCity: departureCity as CityDetailsResult,
          arrivalCity: arrivalCity as CityDetailsResult,
        })}
      >
        {getSearchString()}
      </Button>
    </div>
  );
};
